import {
  createApp
} from 'vue';
import App from './App.vue';
import './plugins/tips';
import * as echarts from 'echarts';
// import Vuex from 'vuex';
import router from './router';
import 'lib-flexible';
import store from './store';
import 'vant/lib/index.css'; // 全局引入样式
import './assets/css/index.css';
import tipsMessage from './plugins/tips.js';
import modalLoading from "./components/loading/index";
import 'vant-touch-emulator';

import {
  ActionBar,
  ActionBarIcon,
  ActionBarButton,
  Divider,
  Popup,
  Overlay,
  Loading,
  Dialog,
  ContactCard,
  Form,
  AddressEdit,
  AddressList,
  Field,
  CellGroup,
  Cell,
  SwipeCell,
  Icon,
  Stepper,
  Card,
  Checkbox,
  CheckboxGroup,
  Button,
  Swipe,
  SwipeItem,
  PullRefresh,
  List,
  Tab,
  Tabs,
  SubmitBar,
  Toast,
  Skeleton,
  RadioGroup,
  Radio,
  Calendar,
  Col,
  Row,
  Area,
  Picker,
  ActionSheet,
  ContactList,
  DatetimePicker,
  Grid,
  GridItem,
  Empty,
  PasswordInput,
  NumberKeyboard,
  Search,
  Image
} from 'vant';



// 创建实例
const app = createApp(App);
// 全局过滤器
app.config.globalProperties.$filters = {
  prefix(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = `http://backend-api-01.newbee.ltd${url}`
      return url
    }
  }
}

app.use(ActionBarButton)
  .use(ActionBarIcon)
  .use(ActionBar)
  .use(Divider)
  .use(DatetimePicker)
  .use(Popup)
  .use(Overlay)
  .use(Loading)
  .use(Dialog)
  .use(Toast)
  .use(ContactCard)
  .use(ContactList)
  .use(Form)
  .use(AddressEdit)
  .use(AddressList)
  .use(Field)
  .use(CellGroup)
  .use(Cell)
  .use(SwipeCell)
  .use(Icon)
  .use(Stepper)
  .use(Card)
  .use(Button)
  .use(Swipe)
  .use(SwipeItem)
  .use(PullRefresh)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(SubmitBar)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Skeleton)
  .use(Radio)
  .use(RadioGroup)
  .use(Calendar)
  .use(Col)
  .use(Row)
  .use(Area)
  .use(Picker)
  .use(ActionSheet)
  .use(Grid)
  .use(GridItem)
  .use(Empty)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(Search)
  .use(Image)
  
// app.use(Vuex)
app.use(router)
app.use(tipsMessage)
app.use(modalLoading)
app.config.globalProperties.$echarts = echarts
app.use(store);

app.mount('#app')
